import { Component, OnInit, Input } from '@angular/core';
import {
  faCheckCircle,
  } from '@fortawesome/free-solid-svg-icons';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-successful-action',
  templateUrl: './successful-action.component.html',
  styleUrls: ['./successful-action.component.scss'],
})
export class SuccessfulActionComponent implements OnInit {
  faCheckCircle = faCheckCircle;
  @Input() message: any;
  constructor(
    private modalCtrl: ModalController

  ) { }

  ngOnInit() {}

  close() {
    try {
      this.modalCtrl.dismiss();
    } catch (e) {
      // failed to dismiss probably already happened
    }
  }

}
